import { Button } from 'antd';
import { ReportsAccessProvider } from '../../../lib/ReportsAccessContext';
import ReportsSearch from '../../navigation/ReportsSearch';
import { SearchOutlined } from '@ant-design/icons';
import ToolkitsSearch from '../../navigation/ToolkitsSearch';
const searchComponentByType = {
  reports: ({
    contextWrap,
    ...props
  }) => contextWrap ? <ReportsAccessProvider children={<ReportsSearch {...props} />} /> : <ReportsSearch {...props} />,
  toolkits: ToolkitsSearch
};
const Search = ({
  name,
  searchType,
  isCollapsed,
  setCollapsed,
  ...props
}) => {
  const Component = searchComponentByType[searchType];
  return <div id={name?.toLowerCase().replace(/\s+/g, '-')} data-sentry-component="Search" data-sentry-source-file="Search.jsx">
      {isCollapsed ? <Button type="ghost" size="large" style={{
      width: '100%'
    }} onClick={() => setCollapsed(false)} icon={<SearchOutlined style={{
      fontSize: 24
    }} />} /> : <Component {...props} />}
    </div>;
};
export default Search;